/**
 * User entity – domain model for athlete profile and subscription.
 */
export const DISCIPLINES = ['powerLifter', 'bodyBuilder', 'strongMan'];

export const DISCIPLINE_LABELS = {
  powerLifter: 'Power Lifter',
  bodyBuilder: 'Body Builder',
  strongMan: 'Strong Man',
};

export function createUser({
  id,
  displayName = '',
  avatarUrl = '',
  bio = '',
  bodyweight = null,
  federation = '',
  nationality = '',
  age = null,
  discipline = '',
  role = 'user',
  stats = {},
  createdAt = null,
  subscriptionStatus = 'free',
  subscriptionId = '',
  isPremium = false,
  verifiedBadge = false,
  subscriptionStartDate = null,
  subscriptionEndDate = null,
}) {
  return {
    id,
    displayName,
    avatarUrl,
    bio,
    bodyweight,
    federation,
    nationality,
    age,
    discipline,
    role,
    stats: {
      squatPr: stats.squatPr ?? null,
      benchPr: stats.benchPr ?? null,
      deadliftPr: stats.deadliftPr ?? null,
      totalPr: stats.totalPr ?? null,
      ...stats,
    },
    createdAt: createdAt?.toDate?.() ?? createdAt ?? null,
    subscriptionStatus,
    subscriptionId,
    isPremium: !!isPremium,
    verifiedBadge: !!verifiedBadge,
    subscriptionStartDate: subscriptionStartDate?.toDate?.() ?? subscriptionStartDate ?? null,
    subscriptionEndDate: subscriptionEndDate?.toDate?.() ?? subscriptionEndDate ?? null,
  };
}

/** True if profile has required onboarding fields set. */
export function isProfileComplete(profile) {
  if (!profile) return false;
  const hasNationality = typeof profile.nationality === 'string' && profile.nationality.trim() !== '';
  const hasAge = typeof profile.age === 'number' && profile.age > 0 && profile.age < 150;
  const hasDiscipline = DISCIPLINES.includes(profile.discipline);
  return hasNationality && hasAge && hasDiscipline;
}
